/**
 * Metodo que retorna el objeto con los filtros
 * @param {*} datos
 */
const getFilterParams = (
    camposFilter,
    currentPage,
    perPage = 5,
    datos = null,
    idFilter = ''
  ) => {
  try {
    let params = { perPage: perPage, page: currentPage, id: idFilter };
    if (Array.isArray(camposFilter)) {
      camposFilter.map((x) => {
        x.elements.map((element) => {
          let paramValue = null;
          if (datos && datos[element.name]) {
            paramValue = datos[element.name].id ?? datos[element.name];
          } else {
            paramValue = element.value ?? '';
          }
          params[element.name] = paramValue;
        });
      });
    }
    return params;
  } catch (error) {
   
  }
  };
  
  /**
   * Obtiene el valor de la posicion de un objecto especifico
   * @param {*} objecto
   * @param {*} positions
   * @returns
   */
  const getObjectPosition = (objecto, positions) => {
    if (objecto && positions) {
      let objFinalPostion = objecto;
      positions.map((item) => {
        try {
          objFinalPostion = objFinalPostion[item];
        } catch (error) {
          return false;
        }
      });
      return objFinalPostion;
    }
    return false;
  };
  
  /**
   * Valida que se muestre o no propiedades en el menu del row table
   * @param {*} x
   * @param {*} item
   * @returns
   */
  const validateShowOptionMenu = (x, item) => {
    if(x.hasOwnProperty('visible')){
      return x.visible(item)
    }
    if (x.hasOwnProperty('showIf')) {
      if (x.showIf.name && item[x.showIf.name] === x.showIf.value) {
        return true;
      }
      if (
        getObjectPosition(item, x.showIf.positions) &&
        getObjectPosition(item, x.showIf.positions) === x.showIf.value
      ) {
        return true;
      }
      if (
        x.showIf.positions &&
        x.showIf.values &&
        x.showIf.values.find(
          (y) => y === getObjectPosition(item, x.showIf.positions)
        )
      ) {
        return true;
      }
      if (
        x.showIf.name &&
        item[x.showIf.name] &&
        x.showIf.values &&
        x.showIf.values.find((y) => y === item[x.showIf.name])
      ) {
        return true;
      }
      return false;
    }
  
    if (x.showIfNot) {
      if (x.showIfNot.name && item[x.showIfNot.name] !== x.showIfNot.value) {
        return true;
      }
      if (
        getObjectPosition(item, x.showIfNot.positions) &&
        getObjectPosition(item, x.showIfNot.positions) !== x.showIfNot.value
      ) {
        return true;
      }
      if (
        x.showIfNot.positions &&
        x.showIfNot.values &&
        x.showIfNot.values.find(
          (y) => y !== getObjectPosition(item, x.showIfNot.positions)
        )
      ) {
        return true;
      }
      if (
        x.showIfNot.name &&
        item[x.showIfNot.name] &&
        x.showIfNot.values &&
        x.showIfNot.values.find((y) => y !== item[x.showIfNot.name])
      ) {
        return true;
      }
      return false;
    }
  };
  export { getFilterParams, getObjectPosition, validateShowOptionMenu };
  